import React, { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useTypedSelector } from '@/store';

type Props = {
  children: React.ReactNode;
};

const AuthLayout: React.FC<Props> = ({ children }) => {
  const history = useNavigate();

  const { isAuth, user } = useTypedSelector(state => state.authUser);

  useEffect(() => {
    // Only redirect verified users away from auth pages
    // Unverified users should stay on auth pages (handled by AuthGuard)
    if (isAuth && user?.isVerified) {
      history('/');
    }
  }, [isAuth, user]);


  return (
    <div className="auth-layout">
      <div className="auth-layout__container">{children}</div>
    </div>
  );
};

export default AuthLayout;
